<template>
  <div class="search-bar" :class="{ 'hidden': hidden }">
    <form v-on:submit.prevent="onSubmit">
      <div class="flex flex-row">
        <input type="text"
               class="flex-grow px-4 py-2"
               :value="value"
               :placeholder="placeholder"
               @input="onTextChange($event.target.value)"/>
        <button type="submit" class="bg-cal-81B920 text-white px-4 py-2">{{ button }}</button>
      </div>

    </form>
  </div>
</template>

<script>
export default {
  props: {
    value: String,
    hidden: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      default: "Enter keyword"
    },
    button: {
      type: String,
      default: 'Search',
    }
  },
  methods: {
    onTextChange(value) {
      this.$emit("input", value);
    },
    onSubmit() {
      this.$emit("search", this.value);
    }
  }
}
</script>
